import { Injectable, inject } from "@angular/core";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { AppRouter } from "@magpie/edge";
import superjson from "superjson";
import { environment } from "./environment";
import { StorageKeys, StorageService } from "./storage.service";

@Injectable({
	providedIn: "root",
})
export class TrpcService {
	private readonly storage = inject(StorageService);
	private _client: ReturnType<typeof createTRPCClient<AppRouter>> | null = null;

	get client() {
		if (!this._client) {
			const storage = this.storage;
			this._client = createTRPCClient<AppRouter>({
				links: [
					httpBatchLink({
						url: `${environment.serverUrl}/api/trpc`,
						transformer: superjson,
						async headers() {
							const token = await storage.get<string>(StorageKeys.AuthToken);
							return token ? { Authorization: `Bearer ${token}` } : {};
						},
						fetch: (url, options) =>
							fetch(url, { ...options, signal: AbortSignal.timeout(15_000) }),
					}),
				],
			});
		}
		return this._client;
	}
}
